import axios from 'axios'

// const url = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ?
//     'https://localhost:3000' :
//     'https://fixedmatches-api-with-wombat.jarek.now.sh/'

const url = 'https://8qyd7upi3f.execute-api.eu-central-1.amazonaws.com/dev'

axios.defaults.baseURL = url

export default axios
